import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import mediaFullSchema from '@utils/validate/blocksSchemes/mediaFullSchema';
const slideTypeSchema = Joi.object({
  id: Joi.number().required().allow(''),
  name: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required()
}).unknown(true);
const categoryCollectionCarouselSlideSchema = Joi.object({
  title: Joi.string().allow('', null).required(),
  titleColor: Joi.string().allow('', null).required(),
  image: mediaUrlSchema.required(),
  imageWithBlur: imagesWithBlurSchema,
  video: mediaFullSchema(true) || mediaUrlSchema,
  id: Joi.number().required(),
  textColor: Joi.allow(),
  link: Joi.allow(),
  slideType: slideTypeSchema
}).unknown(true);
export default categoryCollectionCarouselSlideSchema;